
export class Refrigeration {
  constructor(
    public hash?: string,
    public name?: string,
    public value?: string
  ) { }

  clone() {
    return new Refrigeration(
      this.hash,
      this.name,
      this.value
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/refrigeration.ts